import { LegacyContext } from '../types/auth';

let legacyContext: LegacyContext | null = null;
let accessToken: string | null = null;

export const setLegacyContext = (context: LegacyContext | null) => {
  legacyContext = context;
};

export const getLegacyContext = () => legacyContext;

export const setAccessToken = (token: string | null) => {
  accessToken = token;
};

export const getAccessToken = () => accessToken;
